import React, { ReactNode } from 'react';
import { createStyles } from 'app/utils/css';
import { GREY_G, GREY_U } from 'app/constants/Colors';

interface IProps {
  children?: ReactNode;
}

const Separator = ({ children }: IProps) => (
  <Styles>{css =>
    <div className={css('separatorContainer')}>
      <div className={css('separatorLine')} />

      {children &&
        <div className={css('separatorContent')}>
          {children}
        </div>}

      <div className={css('separatorLine')} />
    </div>
  }</Styles>
);

const Styles = createStyles({
  separatorContainer: {
    display: 'flex',
  },
  separatorLine: {
    flexGrow: 1,
    alignSelf: 'center',
    borderBottom: `1px solid ${GREY_U}`,
    minWidth: '20px',
  },
  separatorContent: {
    color: GREY_G,
    marginLeft: '10px',
    marginRight: '10px',
  },
});

export default Separator;
